@if( hasSearch() ){

  <div #searchWrapper class="relative" [class]="{'hidden': hideSearchByView}">

    <!-- SEARCHER -->
    <!-- Empieza tras el toggle (32px medidos + 8px de gap); en movil llega al gutter derecho: 100vw - 16 - 40 - 16. -->
    <div #searchContainer class="absolute top-0 left-[40px] z-[1] flex items-center opacity-0 w-[calc(100vw-72px)] md:w-[300px]" [class]="{'hidden': !showSearch}">

      <!-- SEARCH INPUTS -->
      @switch (type()) {
        <!-- SIMPLE SEARCH -->
        @case (searchTypes.Simple) {
          <app-search-simple
            />
        }
        <!-- ADVANCED SEARCH -->
        @case (searchTypes.Advanced) {
          <app-search-advanced
            [data]="fileData()"
            />
        }
      }

    </div>

    <!-- SEARCH TOGGLE -->
    <!-- Una sola pastilla que cambia de icono en el sitio. Los dos svg se proyectan estaticos porque ngProjectAs no cruza un @if. -->
    <app-button
      [type]="buttonType"
      [color]="searchActive() ? buttonColors.White : buttonColors.Default"
      [disabled]="isAnimating()"
      (click)="toggleSearchButton()"
      >

      <svg data-icon="search" ngProjectAs="icon" [class]="{'hidden': searchActive()}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="size-3.5 rotate-90">
        <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
      </svg>

      <svg data-icon="close" ngProjectAs="icon" [class]="{'hidden': !searchActive()}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-3.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
      </svg>

    </app-button>

  </div>

}
